import { render, staticRenderFns } from "./Emoji.vue?vue&type=template&id=340288d2&"
import script from "./Emoji.vue?vue&type=script&lang=ts&"
export * from "./Emoji.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports